import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation, faRotateRight } from '@fortawesome/free-solid-svg-icons';
import { CustomerButton } from './CustomerButton';

interface CustomerErrorStateProps {
  message: string;
  onRetry?: () => void;
  retryLabel?: string;
}

/** One error surface for every customer page — replaces five copies of the same block. */
export function CustomerErrorState({
  message,
  onRetry,
  retryLabel = 'Try again',
}: CustomerErrorStateProps) {
  return (
    <div
      role="alert"
      className="flex flex-col items-center gap-3 rounded-customer border border-customer-border bg-customer-surface px-4 py-10 text-center shadow-customer-sm"
    >
      <span
        className="flex h-12 w-12 items-center justify-center rounded-full bg-customer-warning/15 text-customer-warning-text"
        aria-hidden="true"
      >
        <FontAwesomeIcon icon={faTriangleExclamation} className="h-5 w-5" />
      </span>
      <p className="max-w-sm text-sm text-customer-text">{message}</p>
      {onRetry && (
        <CustomerButton variant="primary" icon={faRotateRight} onClick={onRetry}>
          {retryLabel}
        </CustomerButton>
      )}
    </div>
  );
}
